var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuessLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.472,
    height: 18.09,
    viewBox: "0 0 14.472 18.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26905",
    "data-name": "Trac\\xE9 26905",
    d: "M12.523,11.236h.9a.9.9,0,0,0,0-1.809h-.9a.9.9,0,0,0,0,1.809Zm0,1.809a.9.9,0,0,0,0,1.809H17.95a.9.9,0,0,0,0-1.809Zm9.95-2.768a1.185,1.185,0,0,0-.054-.244V9.952a.964.964,0,0,0-.172-.253h0L16.819,4.271h0a.964.964,0,0,0-.253-.172.246.246,0,0,0-.081,0,.777.777,0,0,0-.3-.1H10.714A2.716,2.716,0,0,0,8,6.714V19.377a2.716,2.716,0,0,0,2.714,2.713h9.045a2.716,2.716,0,0,0,2.714-2.713v-9.1ZM17.045,7.084l2.343,2.343H17.95a.907.907,0,0,1-.9-.9Zm3.618,12.292a.907.907,0,0,1-.9.9H10.714a.907.907,0,0,1-.9-.9V6.714a.907.907,0,0,1,.9-.9h4.523V8.523a2.716,2.716,0,0,0,2.714,2.714h2.713ZM17.95,16.663H12.523a.9.9,0,1,0,0,1.809H17.95a.9.9,0,0,0,0-1.809Z",
    transform: "translate(-8 -4)",
    fill: "#6f7070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuessLogs);
export default __webpack_public_path__ + "static/media/quess_logs.b548de42637104c9427976dc537797e2.svg";
export { ForwardRef as ReactComponent };